console.debug("AwayFL - AVM1 - 0.2.96");
export { AVM1Handler } from "./lib/AVM1Handler";
export { AVM1SceneGraphFactory } from "./lib/AVM1SceneGraphFactory";
export { AVM1ContextImpl } from "./lib/interpreter";
export { AVM1MovieClip } from "./lib/lib/AVM1MovieClip";
export { AVM1Globals, TraceLevel } from "./lib/lib/AVM1Globals";
export { AVM1Object } from "./lib/runtime/AVM1Object";
export { AVM1Button } from "./lib/lib/AVM1Button";
export { AVM1PropertyDescriptor } from "./lib/runtime/AVM1PropertyDescriptor";
export { wrapAVM1NativeClass } from "./lib/lib/AVM1Utils";
export { AVM1Context } from "./lib/context";
//export {Debug, release} from "./lib/factories/base/utilities/Debug";
export { alIsFunction } from "./lib/runtime";
// export {BaseVector} from "./lib/factories/avm2/natives/GenericVector";
// export {Player} from "./lib/factories/player/Player";
// export {PlayerAVM1} from "./lib/factories/player/PlayerAVM1";
export { alIsArray } from './lib/runtime';
export { alNewObject } from './lib/runtime';
export { AVM1ArrayNative } from './lib/natives';
export { SecurityDomain } from './lib/SecurityDomain';
export { SharedObjectDebug } from "./lib/lib/AVM1SharedObject";
